import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from "redux";

class Research extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        if (!this.props.research || this.props.isLoading) {
            return (<div></div>);
        }


        let researchProjects = this.props.research.map((item, index) => {
            let anchor = item.anchor;
            if (!anchor) {
                anchor = item.title.split(' ').join('');
            }
            let titleHtml = item.titleLine1;
            if (item.titleLine2 && item.titleLine2.length > 0) {
                titleHtml = titleHtml + '<br />' + item.titleLine2;
            }
            return <div key={index} className="col-3 menu-card research-card mx-2 my-2">
                <div className="vertical-align-middle">
                    <Link to={`/projectItem/${anchor}`}>
                        <div style={{ height: "50px" }} dangerouslySetInnerHTML={{ __html: titleHtml }}></div>
                        <div className="py-3 yellow-text" >&#8594;</div >
                    </Link>
                </div>
            </div>;
        });
        return (
            <div id="SectionContainer">
                <section className="content">
                    <div className="container">
                        <h1>Our Projects</h1>
                        <p></p>
                        <div className="row">
                            {researchProjects}
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        research: state.siteData.siteData.research,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const ResearchContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(
    Research
));

export default ResearchContainer;


// WEBPACK FOOTER //
// ./src/components/Research/Research.tsx